import { HiddenField } from "@/components/Form/Parts/index";
import PaymentIconImage from "@/components/Images/PaymentIconImage";
import { PAYMENT_METHOD_ID } from "@/lib/constants";
import formStyles from "@/styles/Form.module.scss";
import styles from "@/styles/PaymentSelect.module.scss";
import classnames from "classnames";
import { useCallback, useMemo, useState } from "react";
import { CREATE_ONLY_MODE, IGNORE_CARRIER, IGNORE_PAYPAY } from "./index";
import PaymentRadioButton from "./PaymentRadioButton";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function PaymentInstrumentsList(_ref) {
  let {
    mode,
    paymentInstruments,
    register,
    onChange
  } = _ref;
  if (CREATE_ONLY_MODE.includes(mode)) return null;
  if (!paymentInstruments) return null;
  const {
    0: selectPaymentInstrument,
    1: setSelectPaymentInstrument
  } = useState(0);
  // 支払い方法ごとに分ける
  const creditCard = useMemo(() => {
    return paymentInstruments.filter(v => v.payment_method_id === PAYMENT_METHOD_ID.CREDIT_CARD_3DS || v.payment_method_id === PAYMENT_METHOD_ID.CREDIT_CARD_NO3DS);
  }, [paymentInstruments]);
  const paypay = useMemo(() => {
    return paymentInstruments.filter(v => !IGNORE_PAYPAY.includes(mode) && v.payment_method_id === PAYMENT_METHOD_ID.PAYPAY);
  }, [mode, paymentInstruments]);
  const carrier = useMemo(() => {
    return paymentInstruments.filter(v => !IGNORE_CARRIER.includes(mode) && [PAYMENT_METHOD_ID.AU, PAYMENT_METHOD_ID.DOCOMO, PAYMENT_METHOD_ID.SOFTBANK].includes(v.payment_method_id));
  }, [mode, paymentInstruments]);
  const handleClick = useCallback(id => {
    return () => setSelectPaymentInstrument(Number(id));
  }, []);
  const handleChange = useCallback(e => {
    onChange({
      paymentMethod: e.target.value,
      createPayment: false,
      showInput: false
    });
  }, []);
  const cardNumber = useCallback(v => {
    return " ****-****-****-" + v.values.card_number;
  }, []);
  const labelClassName = useCallback(v => {
    var _v$values;
    const cardType = v === null || v === void 0 || (_v$values = v.values) === null || _v$values === void 0 ? void 0 : _v$values.card_type;
    return classnames(styles.radioCheck, styles.paymentMethodIcon, {
      [styles.visa]: cardType === "visa",
      [styles.jcb]: cardType === "jcb",
      [styles.master]: cardType === "mastercard",
      [styles.amex]: cardType === "amex",
      [styles.diners]: cardType === "dinersclub",
      [styles.paypay]: v.payment_method_id === PAYMENT_METHOD_ID.PAYPAY,
      [styles.docomo]: v.payment_method_id === PAYMENT_METHOD_ID.DOCOMO,
      [styles.softbank]: v.payment_method_id === PAYMENT_METHOD_ID.SOFTBANK,
      [styles.au]: v.payment_method_id == PAYMENT_METHOD_ID.AU
    });
  }, []);
  return /*#__PURE__*/_jsxs("fieldset", {
    className: `${formStyles.marginOff} ${styles.paymentInstrumentsListFieldset}`,
    children: [/*#__PURE__*/_jsx("p", {
      className: styles.paymentInstrumentsListFieldsetTitle,
      children: "\u3054\u767B\u9332\u6E08\u307F\u306E\u304A\u652F\u6255\u3044\u65B9\u6CD5\u3092\u5229\u7528\u3059\u308B"
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.paymentInstrumentStyle,
      children: [creditCard && /*#__PURE__*/_jsx(_Fragment, {
        children: creditCard.map(v => /*#__PURE__*/_jsx(PaymentRadioButton, {
          ref: register,
          paymentMethodId: v.payment_method_id,
          id: `paymentInstrumentId${v.payment_instrument_id}`,
          className: labelClassName(v),
          value: v.payment_method_id,
          onChange: handleChange,
          onClick: handleClick(v.payment_instrument_id),
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.iconWithText,
            children: [/*#__PURE__*/_jsx(PaymentIconImage, {
              large: true,
              paymentMethodId: v.payment_method_id,
              cardType: v.values.card_type,
              className: styles.cardImage
            }), /*#__PURE__*/_jsx("span", {
              className: styles.paymentCreditCardText,
              children: v.payment_method.name
            }), /*#__PURE__*/_jsx("span", {
              className: styles.paymentCreditCardText,
              children: cardNumber(v)
            })]
          })
        }, `paymentInstrument-${v.payment_instrument_id}`))
      }), paypay && /*#__PURE__*/_jsx(_Fragment, {
        children: paypay.map(v => /*#__PURE__*/_jsx(PaymentRadioButton, {
          ref: register,
          paymentMethodId: v.payment_method_id,
          id: `paymentInstrumentId${v.payment_instrument_id}`,
          className: labelClassName(v),
          value: v.payment_method_id,
          onChange: handleChange,
          onClick: handleClick(v.payment_instrument_id),
          children: /*#__PURE__*/_jsx(PaymentIconImage, {
            large: true,
            paymentMethodId: v.payment_method_id,
            cardType: v.values.card_type
          })
        }, `paymentInstrument-${v.payment_instrument_id}`))
      }), carrier && /*#__PURE__*/_jsx("div", {
        className: styles.carrierPayments,
        children: carrier.map(v => /*#__PURE__*/_jsx(PaymentRadioButton, {
          ref: register,
          paymentMethodId: v.payment_method_id,
          id: `paymentInstrumentId${v.payment_instrument_id}`,
          className: labelClassName(v),
          value: v.payment_method_id,
          onChange: handleChange,
          onClick: handleClick(v.payment_instrument_id),
          children: /*#__PURE__*/_jsx(PaymentIconImage, {
            large: true,
            paymentMethodId: v.payment_method_id,
            cardType: v.values.card_type
          })
        }, `paymentInstrument-${v.payment_instrument_id}`))
      }), /*#__PURE__*/_jsx(HiddenField, {
        ref: register,
        name: "paymentInstrument",
        value: selectPaymentInstrument
      })]
    })]
  });
}